import React from "react";
import styled from "styled-components";
import { TextFont, Colors, Text } from "../../config";

const LabelAndAmount = ({
  label,
  amount,
  amountFontSize = "0.75rem",
  grayQar = false,
  amountFontColor = Colors.sharkApprox,
}) => {
  return (
    <LabelAndAmountWrapper>
      {label && (
        <TextFont fontColor={Colors.bombay} fontSize="0.75rem" fontWeight="500">
          {label}
        </TextFont>
      )}
      <DispFlex>
        <TextFont
          fontColor={amountFontColor}
          fontSize={amountFontSize}
          fontWeight="700"
        >
          {amount} {!grayQar && Text.qar}
        </TextFont>
        {grayQar && (
          <TextFont
            fontColor={Colors.sharkApproxOpacity40}
            fontSize="0.75rem"
            fontWeight="400"
          >
            {Text.qar}
          </TextFont>
        )}
      </DispFlex>
    </LabelAndAmountWrapper>
  );
};

export default LabelAndAmount;

const LabelAndAmountWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.375rem 0 0.375rem 0.375rem;
`;
const DispFlex = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: baseline;
`;
